function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function PowerSwitch(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.919 2.762a10.409 10.409 0 016.476 9.66c0 5.757-4.683 10.44-10.44 10.44-5.771 0-10.455-4.683-10.455-10.44 0-4.252 2.542-8.044 6.476-9.66a1 1 0 01.76 1.85 8.417 8.417 0 00-5.236 7.81c0 4.655 3.787 8.44 8.44 8.44 4.669 0 8.455-3.785 8.455-8.44a8.415 8.415 0 00-5.236-7.81 1 1 0 11.76-1.85zM11.948 1a1 1 0 011 1v10.011a1 1 0 11-2 0V2a1 1 0 011-1z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
const MemoPowerSwitch = /*#__PURE__*/React.memo(PowerSwitch);
export default MemoPowerSwitch;